module.exports = __webpack_public_path__ + "assets/job.b6da1ffe.svg";